<template>
<div class="cardLockInfo table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">锁卡列表</span>
        <el-form inline class="hook right themed-form search-form" v-model="form" style="line-height: 40px;">
            <el-form-item label="IMEI号:">
                <el-input v-model="form.imei" @input="validateImei"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="openAddDialog">新增</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="content-box">
        <el-table ref="table" :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="IMEI号" prop="imei" show-overflow-tooltip></el-table-column>
            <el-table-column label="锁定卡槽" prop="lockStatus" show-overflow-tooltip>
                <template slot-scope="scope">
                    卡槽{{ parseInt(scope.row.lockStatus) + 1 }}
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" class="themed-button" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 50, 100]"
            :page-size="pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
    </div>

    <!-- 新增弹窗 -->
    <el-dialog title="新增锁卡" :visible.sync="dialogVisible" width="500px" v-if="dialogVisible">
        <el-form :model="dialogForm" ref="dialogForm" :rules="rules" label-width="120px">
            <el-form-item label="IMEI号" prop="imeis">
                <el-input v-model="dialogForm.imeis" type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入IMEI，换行分割" @input="validateImeis"></el-input>
            </el-form-item>
            <el-form-item label="锁定卡槽" prop="lockStatus">
                <el-select v-model="dialogForm.lockStatus" placeholder="请选择卡槽">
                    <el-option label="卡槽1" value="0"></el-option>
                    <el-option label="卡槽2" value="1"></el-option>
                    <el-option label="卡槽3" value="2"></el-option>
                    <el-option label="卡槽4" value="3"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { listCardLock, batchSaveCardLock, deleteCardLock } from '@/api/meCardBindManagement/cardLockInfo.js'
import { messageBox } from '@/utils/common.js'
import resize from '@/mixins/resize.js'

export default {
    mixins: [resize],
    data() {
        return {
            form: {
                imei: ''
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            
            dialogVisible: false,
            dialogForm: {
                imeis: '',
                lockStatus: ''
            },
            rules: {
                imeis: [
                    { required: true, message: '请输入IMEI号', trigger: 'blur' }
                ],
                lockStatus: [
                    { required: true, message: '请选择锁定卡槽', trigger: 'change' }
                ]
            }
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        // 获取列表数据
        fetchData() {
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form
            }
            listCardLock(params).then(res => {
                this.tableData = res.rows || []
                this.total = res.total || 0
            })
        },
        // 搜索
        searchData() {
            this.currentPage = 1
            this.fetchData()
        },
        // 打开新增弹窗
        openAddDialog() {
            this.dialogForm = {
                imeis: '',
                lockStatus: ''
            }
            this.dialogVisible = true
        },
        // 删除
        handleDelete(row) {
            this.$confirm('确认删除该记录吗？').then(() => {
                deleteCardLock({ id: row.id }).then(res => {
                    if (res.code === '0') {
                        messageBox(this, '删除成功')
                        this.fetchData()
                    }
                })
            })
        },
        // 提交表单
        submitForm() {
            this.$refs.dialogForm.validate(valid => {
                if (valid) {
                    batchSaveCardLock(this.dialogForm).then(res => {
                        if (res.code === '0') {
                            messageBox(this, '操作成功')
                            this.dialogVisible = false
                            this.fetchData()
                        }
                    })
                }
            })
        },
        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fetchData()
        },
        // IMEI号输入验证（只允许数字）
        validateImei(value) {
            this.form.imei = value.replace(/\D/g, '');
        },
        // 批量IMEI号输入验证（只允许数字和换行）
        validateImeis(value) {
            this.dialogForm.imeis = value.replace(/[^\d\n]/g, '');
        },
    }
}
</script>

<style lang="scss" scoped>
.cardLockInfo {
    padding: 20px;
    background-color: #fff;
    border-radius: 4px;
    
    .title-box {
        margin-bottom: 20px;
    }
    
    .content-box {
        margin-bottom: 20px;
    }
    
    .pagination {
        text-align: right;
    }
}
</style>
